import React from 'react';
import { Row, Col } from 'antd';
import styled from 'styled-components/macro';

import Heading from 'components/Heading/Heading';
import { buildHostRegistrationHostFormRoute, buildHostRegistrationPropertyFormRoute, buildHostRegistrationSuccessRoute } from 'utils/routes';

import RegisterBg from './../../images/enq-info-bg.png';
import RegisterMailIcon from './../../images/host-register-img.png';
import ProgressIndicator from 'components/ProgressIndicator/ProgressIndicator';

const STEPS = [
  {
    path: buildHostRegistrationHostFormRoute(),
    label: 'Your profile',
    isActive: false
  },
  {
    path: buildHostRegistrationPropertyFormRoute(),
    label: 'Your properties',
    isActive: false
  },
  {
    path: buildHostRegistrationSuccessRoute(),
    label: 'Complete!',
    isActive: false
  }
];

const EnquiryImage = styled.img`
  max-height: 100%;
  max-width: 100%;
`;

const HostRegistrationProgressIndicator = ({ currentPath }) => {
  return (
    <Container>
      <InnerContainerRow type="flex" justify="center" align="top">
        <Col span={16}>
          <StyledRegistrationHeader />
        </Col>
        <Col span={16} type="flex" justify="center">
          <StyledProgressBar currentPath={currentPath} />
        </Col>
        <Col span={16}>
          <EnquiryImage alt="enquiry big email" src={RegisterMailIcon} />
        </Col>
      </InnerContainerRow>
    </Container>
  );
};

const HostRegistrationHeader = ({ className }) => {
  return (
    <Col span={24} lg={16} className={className}>
      <Heading size="sub" color="white">
        Join The Host Community!
      </Heading>
    </Col>
  );
};

const StyledRegistrationHeader = styled(HostRegistrationHeader)`
  display: flex;
  flex-direction: row;
`;

const ProgressBar = ({ currentPath }) => <ProgressIndicator steps={STEPS} currentPath={currentPath} />;

const StyledProgressBar = styled(ProgressBar)`
  margin-top: 24px;
`;

const Container = styled.div`
  background-image: url(${RegisterBg});
  width: 100%;
  background-size: cover;
  color: white;
  padding: 48px 0px;

  @media (min-width: 992px) {
    background-image: url(${RegisterBg});
    width: 32%;
    background-size: cover;
    color: white;
    padding: 48px 0px;
  }
`;

const InnerContainerRow = styled(Row)`
  @media (min-width: 992px) {
    height: 800px;
  }
`;

export default HostRegistrationProgressIndicator;
